import CheckBox from '@app/components/CheckBox'
import InfiniteScrollList from '@app/components/InfiniteScrollList'
import SystemNotificationItem from '@app/components/SystemNotificationItem'
import { INotification } from '@app/models/Notification'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { RouteComponentProps } from 'react-router-dom'
import {
  actionCreators,
  INotificationsListState,
} from '../modules/notificationsList'

type ComponentProps = INotificationsListState &
  typeof actionCreators &
  RouteComponentProps<{}>

export default class NotificationsListPage extends React.PureComponent<
  ComponentProps
> {
  private listRef: React.RefObject<InfiniteScrollList>

  constructor(props: ComponentProps) {
    super(props)

    bindFunctions(this)

    this.listRef = React.createRef<InfiniteScrollList>()
  }

  public componentDidUpdate() {
    if (this.props.itemChangedIndex !== undefined) {
      if (this.listRef.current) {
        this.listRef.current.recomputeRowHeights(this.props.itemChangedIndex)
      }
      this.props.resetItemChangedIndex()
    }
  }

  public componentWillUnmount() {
    this.props.resetState()
  }

  public render() {
    return (
      <DocumentTitle title='Listings'>
        <div className='container d-flex flex-column h-100 pt-3'>
          <div>
            <h3>Notifications</h3>
            <CheckBox
              onChange={this._onChangeUnseenOnly}
              value={this.props.unseenOnly}
            >
              Only see your unseen notifications
            </CheckBox>
          </div>
          <div>
            <InfiniteScrollList
              autoHeight
              cacheKeyMapper={this._cacheKeyMapper}
              isLoading={this.props.isLoading}
              items={this.props.items}
              rowHeight={52}
              loadItems={this.props.loadNotifications}
              noRowsRenderer={this._noRowsRenderer}
              totalItems={this.props.totalItems}
              ref={this.listRef}
              rowRenderer={this._rowRenderer}
            />
          </div>
        </div>
      </DocumentTitle>
    )
  }

  private _cacheKeyMapper(item: INotification) {
    return item.id
  }

  private _noRowsRenderer() {
    return <div>No notifications</div>
  }

  private _onChangeUnseenOnly(newUnseenOnly: boolean) {
    this.props.setUnseenOnly(newUnseenOnly)
    this._reloadData()
  }

  private _reloadData() {
    if (this.listRef.current) {
      this.listRef.current.forceReloadData()
    }
  }

  private _rowRenderer(item: INotification, index: number) {
    // @ts-expect-error - SystemNotificationItem expects different props than what's passed
    return <SystemNotificationItem item={item} />
  }
}
